import brands from './brands.json';

export interface Brand {
  slug: string;
  name: string;
}

const REPO = 'VoltAgent/awesome-design-md';
const TLDS = new Set(['app', 'ai', 'com', 'io', 'dev', 'co']);

export function rawUrl(slug: string): string {
  return `https://raw.githubusercontent.com/${REPO}/main/design-md/${slug}/DESIGN.md`;
}

export function apiTreeUrl(): string {
  return `https://api.github.com/repos/${REPO}/git/trees/main?recursive=1`;
}

/** Human label from a slug: drop a trailing TLD-like segment, split on
 *  separators, Title Case. e.g. "linear.app" -> "Linear", "bmw-m" -> "Bmw M". */
export function deriveName(slug: string): string {
  const dotParts = slug.split('.');
  if (dotParts.length > 1 && TLDS.has(dotParts[dotParts.length - 1])) dotParts.pop();
  const core = dotParts.join('.');
  return core
    .split(/[-.\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/** "design-md/<slug>/DESIGN.md" -> slug; anything else -> null. */
export function slugFromTreePath(path: string): string | null {
  const m = path.match(/^design-md\/([^/]+)\/DESIGN\.md$/);
  return m ? m[1] : null;
}

export function bundledBrands(): Brand[] {
  return brands as Brand[];
}
